import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import browserHistory from 'components/utility/history';
import Fuse from 'fuse.js';
import { ErrorPage } from 'axway-react-ui';
import ModelDesignInitiator from './ModelDesignInitiator';
import ModelsListView from '../view/ModelsListView';
import GenerateEndpoints from '../container/GenerateEndpoints';
import * as actions from '../actions';

class ModelsList extends React.Component {
	constructor(props) {
		super(props);
		this.onCreateModel = this.onCreateModel.bind(this);
		this.onComposeModel = this.onComposeModel.bind(this);
		this.onEditModel = this.onEditModel.bind(this);
		this.onViewModel = this.onViewModel.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onGenerateEndpoints = this.onGenerateEndpoints.bind(this);
		this.setupFuse = this.setupFuse.bind(this);

		this.state = {
			searchFilter: null
		};

		// distance x threshold = no. of chars it will search within (starting from the left)
		this.fuseOpts = {
			threshold: 0.1,
			distance: 1000,
			keys: [ 'name' ]
		};
		if (props.models) {
			this.fuse = new Fuse(props.models, this.fuseOpts);
		}
	}

	setupFuse(newModels) {
		if (newModels) {
			this.fuse = new Fuse(newModels, this.fuseOpts);
		}
	}

	componentWillReceiveProps(props) {
		this.setupFuse(props.models);
	}

	onSearch(searchFilter) {
		this.setState({
			searchFilter
		});
	}

	/**
	 * Bring up the dialog to confirm generation
	 * @param  {object} model The model to generate flows/endpoints for
	 */
	onGenerateEndpoints(model) {
		this.props.actions.confirmGenerateEndpoints({
			modelForEndpoint: model
		});
	}

	/**
	 * On create request the initial model details before navigating to the creation page.
	 */
	onCreateModel() {
		this.props.actions.designModel({
			mode: 'create',
			modelParent: null,
			modelSource: null,
			queryState: true
		});
	}

	/**
	 * On compose request the initial model details before navigating to the creation page.
	 */
	onComposeModel(model) {
		this.props.actions.designModel({
			mode: 'compose',
			modelParent: model.name,
			modelSource: null,
			queryState: true
		});
	}

	/**
	 * On edit just navigate straight to the model design page for the model.
	 */
	onEditModel(model) {
		const name = typeof model === 'string' ? encodeURIComponent(model) : encodeURIComponent(model.name);
		browserHistory.push(`${window.$conf.prefix}/project/models/${name}/edit`);
	}

	/**
	 * On view just navigate straight to the model summary page.
	 */
	onViewModel(model) {
		const name = typeof model === 'string' ? encodeURIComponent(model) : encodeURIComponent(model.name);
		browserHistory.push(`${window.$conf.prefix}/project/models/${name}`);
	}

	applySearchFilter(items) {
		if (!this.fuse) {
			// try to instantiate fuse. This happens if the view
			// didn't recieve any props yet (such as already having models)
			this.setupFuse(this.props.models);
		}
		if (this.state.searchFilter) {
			return this.fuse.search(this.state.searchFilter);
		}
		return items;
	}

	render() {
		const { loading, error, errorDetail, models, apiSpecTypes } = this.props;

		if (error) {
			return	<ErrorPage errorDetail={errorDetail} />;
		} else {
			const filteredModels = this.applySearchFilter(models);
			return (
				<div>
					<GenerateEndpoints />
					<ModelDesignInitiator />
					<ModelsListView
						models={filteredModels}
						apiSpecTypes={apiSpecTypes}
						onCreateModel={this.onCreateModel}
						onEditModel={this.onEditModel}
						onComposeModel={this.onComposeModel}
						onGenerateEndpoints={this.onGenerateEndpoints}
						onViewModel={this.onViewModel}
						onSearch={this.onSearch}
						loading={!models || !apiSpecTypes || loading}
					/>
				</div>
			);
		}
	}
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

function mapStateToProps(state) {
	let models = [];
	// Convert models to array
	if (state.models.models) {
		models = Object.keys(state.models.models).sort().map((model, i) => ({
			key: i,
			...state.models.models[model]
		}));
	}

	return {
		error: state.models.error,
		errorDetail: state.models.errorDetail,
		models,
		loading: state.models.loading,
		modelForEndpoint: state.models.modelForEndpoint,
		apiSpecTypes: state.apidocs.apiSpecTypes.types
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ModelsList);
